import { createContext } from 'react';
import { type ListStyleStruct } from '@/types';

export interface IVectorPanelContext {
    layerId: string;
    isIntl: boolean;
    recordId?: number;
    isVIP?: boolean;
    listStyles: ListStyleStruct[];
    onOpenVIPModal?: () => void;
}

export const VectorPanelContext = createContext<IVectorPanelContext | null>(null);
